(function () {
  const productRequests = new Map();

  function settings() {
    return window.AdvenesFormerPriceSettings || {};
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getProduct(handle) {
    if (!productRequests.has(handle)) {
      const root = window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : '/';
      const request = fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
        credentials: 'same-origin'
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
          return response.json();
        })
        .catch(() => null);
      productRequests.set(handle, request);
    }

    return productRequests.get(handle);
  }

  async function getVariantCompareAtPrices(items) {
    const prices = new Map();
    if (!settings().enabled) return prices;

    const handles = [...new Set(items.map((item) => item.handle).filter(Boolean))];
    const products = await Promise.all(handles.map(getProduct));

    products.filter(Boolean).forEach((product) => {
      product.variants.forEach((variant) => {
        if (variant.compare_at_price) {
          prices.set(Number(variant.id), Number(variant.compare_at_price));
        }
      });
    });

    return prices;
  }

  function markup(currentPrice, compareAtPrice, showCurrency) {
    if (!settings().enabled || !compareAtPrice || compareAtPrice <= currentPrice) return '';
    if (!window.Shopify || typeof window.Shopify.formatMoney !== 'function') return '';

    const format = showCurrency ? settings().moneyFormatWithCurrency : settings().moneyFormat;
    const formattedPrice = window.Shopify.formatMoney(compareAtPrice, format);

    return `<span class="advenes-former-price"><s><span class="visually-hidden">${escapeHtml(settings().label)}:</span><span class="advenes-former-price__amount">${escapeHtml(formattedPrice)}</span></s></span>`;
  }

  window.AdvenesFormerPrice = {
    getVariantCompareAtPrices,
    markup
  };
})();
